import Message from './Message';

export default class Channel {
    public id!: number;
    public name!: string;
    public numberOfVisitors!: number;
    public messages: Message[] = [];

    public static fromData(data: any): Channel {
        const channel = new Channel();
        channel.id = data.id;
        channel.name = data.name;
        channel.numberOfVisitors = data.number_of_visitors;

        if (data.messages) {
            channel.messages = data.messages.data.map((messageData: any) => Message.fromData(messageData));
        }

        return channel;
    }
}
